export function addDaysToDate(dateStr: string, delta: number): string {
  const [year, month, day] = dateStr.split("-").map(Number);
  const d = new Date(year!, month! - 1, day! + delta);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function formatShortDate(dateStr: string): string {
  const [, month, day] = dateStr.split("-");
  return `${Number(month)}/${Number(day)}`;
}
